import type {
  GetClubMembersParams,
  ClubEntriesQueryParams,
} from "@membentry/shared-types";

export const CLUBS_QUERY_KEY = "clubs";
export const CLUB_QUERY_KEY = "club";
export const MY_CLUB_QUERY_KEY = "my-club";
export const MY_CLUBS_QUERY_KEY = "my-clubs";
export const CLUB_MEMBERS_QUERY_KEY = "club-members";
export const CLUB_VISIBLE_MEMBERS_QUERY_KEY = "club-visible-members";
export const CLUB_ENTRIES_QUERY_KEY = "club-entries";
export const TODAY_CLUB_ENTRIES_QUERY_KEY = "today-club-entries";
export const CLUB_MEMBERSHIP_QUERY_KEY = "club-membership";
export const RECENT_OCCUPANCY_QUERY_KEY = "recent-occupancy";

export const getClubsQueryKey = (
  page: number,
  pageSize: number,
  search?: string,
) => [CLUBS_QUERY_KEY, page, pageSize, search] as const;

export const getAllClubsInfiniteQueryKey = (searchQuery: string) =>
  [CLUBS_QUERY_KEY, "all", "infinite", searchQuery] as const;

export const getClubByIdQueryKey = (id: number | undefined) =>
  [CLUB_QUERY_KEY, id] as const;

export const getMyClubQueryKey = () => [MY_CLUB_QUERY_KEY] as const;

export const getMyClubsQueryKey = (params?: {
  page?: number;
  pageSize?: number;
  search?: string;
}) => [MY_CLUBS_QUERY_KEY, params?.page, params?.pageSize, params?.search] as const;

export const getMyClubsInfiniteQueryKey = (
  pageSize: number,
  search: string,
) => [MY_CLUBS_QUERY_KEY, "infinite", pageSize, search] as const;

export const getClubMembersQueryKey = (params: GetClubMembersParams) =>
  [
    CLUB_MEMBERS_QUERY_KEY,
    params.clubId,
    params.page,
    params.pageSize,
    params.search,
    params.filters,
  ] as const;

export const getVisibleClubMembersQueryKey = (params: GetClubMembersParams) =>
  [
    CLUB_VISIBLE_MEMBERS_QUERY_KEY,
    params.clubId,
    params.page,
    params.pageSize,
    params.search,
    params.filters,
  ] as const;

export const getClubEntriesQueryKey = (
  clubId: number,
  params: Partial<ClubEntriesQueryParams>,
) => [CLUB_ENTRIES_QUERY_KEY, clubId, params] as const;

export const getTodayClubEntriesQueryKey = (clubId: number) =>
  [TODAY_CLUB_ENTRIES_QUERY_KEY, clubId] as const;

export const getMyClubEntriesQueryKey = (
  params?: Partial<ClubEntriesQueryParams>,
) => [CLUB_ENTRIES_QUERY_KEY, "my-club", params] as const;

export const getMyClubTodayEntriesQueryKey = (
  params?: Partial<ClubEntriesQueryParams>,
) => [TODAY_CLUB_ENTRIES_QUERY_KEY, "my-club", params] as const;

export const getMyClubRecentOccupancyQueryKey = (recentMinutes = 90) =>
  [RECENT_OCCUPANCY_QUERY_KEY, "my-club", recentMinutes] as const;

export const getClubMembershipQueryKey = (clubId: number | undefined) =>
  [CLUB_MEMBERSHIP_QUERY_KEY, clubId] as const;
